(function (w, d) {
	const config = {
		body: {
			noScroll: 'no-scroll',
		},
		backdrop: {
			hide: 'backdrop_hidden',
		},
		cookie: {
			hide: 'popup-cookie_hidden',
		},
		cookieBox: {
			open: 'popup-cookie__box_open',
		},
		cookieCounter: {
			expired: 'is-counter-expired',
		},
		cookieTitle: {
			hide: 'popup-cookie__title_hidden',
		},
		cookieContent: {
			hide: 'popup-cookie__content_hidden',
		},
		policy: {
			accepted: 'policy-accepted',
			necessary: 'policy-necessary',
			performance: 'policy-performance',
			marketing: 'policy-marketing',
		},
		button: {
			hide: 'button_hidden',
			inverted: 'button_inverted',
		}
	};
	const body = d.querySelector('.js-body');
	const backdrop = d.querySelector('.js-backdrop');
	const cookie = d.querySelector('.js-popup-cookie');
	const cookieBox = d.querySelector('.js-popup-cookie-box');
	const cookieCounter = d.querySelector('.js-popup-cookie-counter');
	const checkboxes = d.querySelectorAll('.js-popup-cookie-checkbox');
	const buttonClose = d.querySelector('.js-button-cookie-close');
	const buttonCookieSettings = d.querySelector('.js-button-cookie-settings');
	const buttonAccept = d.querySelector('.js-button-cookie-save-settings');
	const buttonAcceptAll = d.querySelector('.js-button-cookie-accept-all');
	const isProduction = process.env.NODE_ENV !== 'development';
	const throttleTime = 200;
	let perfectScrollbar;

	if (!cookie) return;

	startApp();
	setListeners();

	function sendDataToBackend(cookie) {
		const data = {
			domain: d.domain,
			userAgent: navigator.userAgent,
		}

		fetch("https://blog.maxpay.com/wp-json/visitor/accept", {
			method: 'POST',
			body: JSON.stringify(data),
			mode: 'no-cors',
		})
			.then(() => {
				scriptsFilter(cookie);
			})
			.catch((err) => {
				throw new Error(err.message);
			});
	}

	function startApp() {
		const cookieBody = d.querySelector('.js-popup-cookie-body');
		perfectScrollbar = new PerfectScrollbar(cookieBody);

		if (!getCookie(config.policy.accepted)) {
			showCookie();
		} else {
			if (getCookie(config.policy.marketing)) {
				setMarketingScripts();
			}
			if (getCookie(config.policy.performance)) {
				setHotjarScripts();
				if (!getCookie(config.policy.marketing)) setAnalyticsScripts();
			}
		}
	}

	function setListeners() {
		buttonCookieSettings.addEventListener('click', visibilityCookieSettings);
		buttonClose.addEventListener('click', visibilityCookieSettings);
		buttonAccept.addEventListener('click', acceptSelectedCookie);
		buttonAcceptAll.addEventListener('click', acceptAllCookie);
		w.addEventListener('scroll', throttle(cookieBottomOffset, throttleTime));
	}

	function visibilityCookieSettings() {
		const cookieTitle = d.querySelector('.js-popup-cookie-title');
		const cookieContentShort = d.querySelector('.js-popup-cookie-content-short');
		const cookieContentFull = d.querySelector('.js-popup-cookie-content-full');
		const openText = cookieBox.dataset.popupCookieOpenText;
		const hideText = cookieBox.dataset.popupCookieHideText;
		const isOpen = JSON.parse(cookieBox.dataset.popupCookieOpen);

		cookieBox.classList.toggle(config.cookieBox.open);
		cookieContentFull.classList.toggle(config.cookieContent.hide);
		cookieContentShort.classList.toggle(config.cookieContent.hide);
		buttonClose.classList.toggle(config.button.hide);
		buttonCookieSettings.classList.toggle(config.button.hide);
		buttonAccept.classList.toggle(config.button.hide);
		buttonAcceptAll.classList.toggle(config.button.inverted);
		cookieTitle.innerHTML = isOpen ? openText : hideText;
		cookieBox.dataset.popupCookieOpen = !isOpen;
		if (perfectScrollbar) {
			perfectScrollbar.update();
		}
	}

	function acceptSelectedCookie() {
		hideCookie();
		sendDataToBackend(config.policy.accepted);
	}

	function acceptAllCookie() {
		checkboxes.forEach(checkbox => {
			checkbox.checked = true;
		})
		hideCookie();
		sendDataToBackend(config.policy.accepted);
	}

	function showCookie() {
		cookie.classList.remove(config.cookie.hide);

		if (getCookie(config.cookieCounter.expired)) {
			cookieCounter.innerHTML = 'Website is enabled';
		} else {
			startCounter();
			body.classList.add(config.body.noScroll);
			backdrop.classList.remove(config.backdrop.hide);
		}
	}

	function hideCookie() {
		body.classList.remove(config.body.noScroll);
		cookie.classList.add(config.cookie.hide);
	}

	function scriptsFilter(cookie) {
		const cookieExpires = new Date();
		/** Expires 1 year */
		cookieExpires.setFullYear(cookieExpires.getFullYear() + 1);
		const cookieOptions = {
			...(isProduction && {domain: 'maxpay.com'}),
			path: '/',
			expires: cookieExpires,
		};

		setCookie(cookie, JSON.stringify(true), cookieOptions);

		if (getCookie(config.policy.accepted)) {
			[...checkboxes].reverse().forEach(checkbox => {
				if (checkbox.checked) {
					setCookie(checkbox.id, JSON.stringify(true), cookieOptions);

					if (checkbox.id === config.policy.marketing) {
						setMarketingScripts();
					}
					if (checkbox.id === config.policy.performance) {
						setHotjarScripts();
						if (!getCookie(config.policy.marketing)) setAnalyticsScripts();
					}
				}
			})
		}
	}

	function startCounter() {
		let seconds = 20;
		let counterInterval;

		runCounter();
		setCounterListeners('start');

		function runCounter() {
			resetCounter();
			counterInterval = w.setInterval(CounterHandler, 1000);
		}

		function resetCounter() {
			w.clearInterval(counterInterval);
		}

		function setCounterListeners(state) {
			if (state === 'start') {
				w.addEventListener('focus', runCounter);
				w.addEventListener('blur', resetCounter);
			}
			if (state === 'stop') {
				w.removeEventListener('focus', runCounter);
				w.removeEventListener('blur', resetCounter);
			}
		}

		function CounterHandler() {
			if (seconds === 0) {
				body.classList.remove(config.body.noScroll);
				backdrop.classList.add(config.backdrop.hide);
				cookieCounter.innerHTML = 'Website is enabled';

				setCounterListeners('stop');
				resetCounter();
				if (!getCookie(config.policy.accepted)) {
					sendDataToBackend(config.cookieCounter.expired);
				}
			} else {
				cookieCounter.innerHTML = `Website will be enabled in ${seconds}&nbsp;seconds`;
				seconds--;
			}
		}
	}

	function setCookie(name, value, options) {
		options = options || {};

		let expires = options.expires;

		if (typeof expires == 'number' && expires) {
			const date = new Date();
			/** Expires in seconds */
			date.setTime(date.getTime() + expires * 1000);
			expires = options.expires = date;
		}
		if (expires && expires.toUTCString) {
			options.expires = expires.toUTCString();
		}

		value = encodeURIComponent(value);

		let updatedCookie = name + "=" + value;

		/** Add all parameters to cookie (domain, secure, path etc.) */
		for (let propName in options) {
			if (options.hasOwnProperty(propName)) {
				updatedCookie += "; " + propName;
				let propValue = options[propName];
				if (propValue !== true) {
					updatedCookie += "=" + propValue;
				}
			}
		}

		d.cookie = updatedCookie;
	}

	function getCookie(name) {
		const matches = d.cookie.match(new RegExp(
			"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	function cookieBottomOffset() {
		if (w.innerWidth < 960) {
			cookieBox.style.bottom = '20px';
		} else {
			const bottomOffset = w.calcBottomOffset(75);
			cookieBox.style.bottom = `${bottomOffset}px`;
		}
	}

	function setHotjarScripts() {
		if (w.hasOwnProperty('createHotjarScripts')) {
			w.createHotjarScripts();
		}
	}

	function setAnalyticsScripts() {
		if (w.hasOwnProperty('createAnalyticsScripts')) {
			w.createAnalyticsScripts();
		}
	}

	function setMarketingScripts() {
		if (w.hasOwnProperty('createFacebookScripts')
			&& w.hasOwnProperty('createGtagScripts')
			&& w.hasOwnProperty('createLinkedinScripts')
		) {
			w.createFacebookScripts();
			w.createGtagScripts();
			w.createLinkedinScripts();
		}
	}
})(window, document);
